import React from 'react'
import { Collapse } from '@mui/material'
import ActionAlert from '../theme/ActionAlert'

const ErrorAlert = ({ showError, setShowError, msgTitle, messageText }) => {
  return (
    <div
      style={{
        willChange: 'transform',
        marginTop: '80px',
        // position: 'fixed',
        // top: 0,
        // width: "100%",
        // zIndex: 100,
      }}
    >
      <Collapse in={showError}>
        <ActionAlert
          onClick={() => {
            window.scrollTo(0, '0')
          }}
          onClose={() => {
            setShowError(false)
            window.scrollTo(0, '400')
          }}
          title={msgTitle}
          type="error"
          sx={{ width: '100%' }}
        >
          {messageText}
        </ActionAlert>
      </Collapse>
    </div>
  )
}

export default ErrorAlert
